import { render } from "./Membership_Fees.vue?vue&type=template&id=450ed608"
import script from "./Membership_Fees.vue?vue&type=script&lang=js"
export * from "./Membership_Fees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__